import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import AltesestateIcon from "@icons-rf/alterestate-icon.svg?react";
import SimpleCard from "../../../../../../shared/components/SimpleCard";
import WarnIcon from "@icons-rf/property-panel/warning-red.svg?react";
import { Tooltip } from "@mui/material";
import { FC } from "react";
import dayjs from "dayjs";

const AlterestateCard = () => {
  const {
    PROPERTY_DETAIL: { alterstate, project }
  } = useRealEstateDetailContext();

  if (project.buildings) return <></>;

  return (
    <ContentIcon>
      <Icon />

      <SimpleCard
        showBg={false}
        title="Alterestate"
        icon={
          alterstate.is_failed ? <WarnAlert date={alterstate.is_failed} /> : null
        }
      >
        <TextCompuesto>
          <TextSimple color="blue" size="label" font="gotham" weight="700">
            ¿Esta publicado en Alterestate?
          </TextSimple>
          <TextSimple color="gray" size="label" font="gotham" weight="700">
            {alterstate.is_sync ? "Si" : "No"}
          </TextSimple>
        </TextCompuesto>
        <TextCompuesto>
          <TextSimple color="blue" size="label" font="gotham" weight="700">
            ¿Esta publicado en la red interna Alterestate?
          </TextSimple>
          <TextSimple color="gray" size="label" font="gotham" weight="700">
            {alterstate.is_published ? "Si" : "No"}
          </TextSimple>
        </TextCompuesto>
        {alterstate.is_sync && (
          <TextCompuesto>
            <TextSimple color="blue" size="label" font="gotham" weight="700">
              Comisión de venta en Alterestate
            </TextSimple>
            <TextSimple color="blue" size="label" font="gotham" weight="700">
              {alterstate.commission}%
            </TextSimple>
          </TextCompuesto>
        )}
      </SimpleCard>
    </ContentIcon>
  );
};

export default AlterestateCard;

const Icon = styled(AltesestateIcon as any)`
  position: absolute;
  right: 20px;
  top: 20px;
  height: 30px;
  width: 50px;
`;
const ContentIcon = styled.div`
  position: relative;
`;

const TextCompuesto = styled.div`
  display: grid;
  flex-direction: row;
  grid-template-columns: auto 1fr;
  column-gap: 10px;
  padding: 2px 0;
  // margin-top: -10px;
`;

interface IWarnAlertProps {
  date: string;
}

const WarnAlert: FC<IWarnAlertProps> = props => {
  return (
    <Tooltip
      title={`La sincronización ha fallado el ${dayjs(props.date).format(
        "DD/MM/YYYY"
      )} , si el error persiste favor contactar al equipo de soporte`}
    >
      <div>
        <IconCustom />
      </div>
    </Tooltip>
  );
};

const IconCustom = styled(WarnIcon as any)`
  margin-top: 5px;
  width: 25px;
  height: 25px;
  svg {
    fill: var(--color-red-02);
    color: var(--color-red-02);
  }
`;
